import React from 'react';
import PlanningDetailsItem from '../Domain/PlanningDetailsItem.js';
import PlanningDetailsForReportingItem from '../Domain/PlanningDetailsForReportingItem.js';
import dateTimeHelper from '../Helpers/datetimeHelper.js';
import mathHelper from '../Helpers/mathHelper.js';
import AuthService from './authService.js';

class PlanningDetailsItemService extends React.Component {
  static async GetPlanningDetailsItemsByPricingId(
    orderBy,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const pricingId = mathHelper.ForceConvertToNumber(searchItem.PricingId);
    const url =
      `api/VPlanningDetailsBase/GetvPlanningDetailsBaseByPricingId?` +
      `id=${pricingId}&orderby=${orderBy}&orderDirection=${orderDir}` +
      `&pageNumber=${pageNumber}&numberOfElements=${numberOfElements}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static async GetPlanningDetailsDatesByPricingIds(pricingIds) {
    const pricingIdsJson = JSON.stringify(pricingIds);
    return AuthService.getInstance().CallBackendFunctionPost(
      'api/VPlanningDetailsBase/GetPlanningDetailsDatesByPricingIds',
      pricingIdsJson
    );
  }

  static async GetPlanningDetailsItemsWithFilter(filter, orderBy, orderDirection = 'Asc') {
    filter.StartDate = dateTimeHelper.startOfTheDay(filter.StartDate);
    filter.EndDate = dateTimeHelper.endOfTheDay(filter.EndDate);
    orderBy = orderBy === 'EndDate' ? '' : orderBy;

    const filterJSON = JSON.stringify(filter);
    const url = `api/VPlanningDetailsBase/GetvPlanningDetailsBaseWithFilter?filter=${filterJSON}&orderby=${orderBy}&orderDirection=${orderDirection}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static async GetPlanningDetailsItemsReport(filter, orderBy, orderDirection = 'Asc') {
    filter.StartDate = dateTimeHelper.toYYYYsMMsDD(filter.StartDate);
    filter.EndDate = dateTimeHelper.toYYYYsMMsDD(filter.EndDate);
    orderBy = orderBy === 'EndDate' ? '' : orderBy;

    const filterJSON = JSON.stringify(filter);
    const url = `api/VPlanningDetailsBase/GetvPlanningDetailsBaseReport?filter=${filterJSON}&orderby=${orderBy}&orderDirection=${orderDirection}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static formatDateArray(dateArray) {
    for (let i = 0; i < dateArray.length; i++) {
      dateArray[i] = dateTimeHelper.toYYYYsMMsDD(dateArray[i]);
    }
  }

  static EditMultiplePlanningDetailItems(editedItems, data) {
    const ids = [];
    editedItems.forEach((item) => ids.push(item.PlanningDetailId));
    const idsJSON = JSON.stringify(ids);
    const targetAssignmentRateJSON = JSON.stringify(data.targetAssignmentRate);
    const targetCompletionRateJSON = JSON.stringify(data.targetCompletionRate);

    const url =
      'api/VPlanningDetailsBase/EditMultipleVPlanningDetailsBaseItems/' +
      '?ids=' +
      idsJSON +
      '&numberOfPlannedAssignments=' +
      data.numberOfPlannedAssignments +
      '&applyTargetRate=' +
      data.applyValue.toString() +
      '&targetAssignmentRate=' +
      targetAssignmentRateJSON +
      '&targetCompletionRate=' +
      targetCompletionRateJSON;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static MassStatusUpdate(editedItems, to) {
    const ids = [];
    editedItems.forEach((item) => ids.push(item.PlanningDetailId));
    const idsJSON = JSON.stringify(ids);

    return AuthService.getInstance().CallBackendFunction(
      `api/VPlanningDetailsBase/MassStatusUpdate/?ids=${idsJSON}&to=${to}`
    );
  }

  static EditMultiplePlanningDetailItemsByPricingIds(
    editedPlanningItems,
    applyDateRow,
    newStartDates,
    newEndDates,
    subpanelValues
  ) {
    const pricingIds = [];
    editedPlanningItems.forEach((item) => pricingIds.push(item.PricingId));

    PlanningDetailsItemService.formatDateArray(newStartDates);
    PlanningDetailsItemService.formatDateArray(newEndDates);

    const idsJSON = JSON.stringify(pricingIds);
    const applyDateRowJSON = JSON.stringify(applyDateRow);
    const newStartDatesJSON = JSON.stringify(newStartDates);
    const newEndDatesJSON = JSON.stringify(newEndDates);
    const data = {
      ids: idsJSON,
      applyDateRow: applyDateRowJSON,
      startDates: newStartDatesJSON,
      endDates: newEndDatesJSON,
      subpanelValues
    };
    const url = 'api/VPlanningDetailsBase/EditMultipleVPlanningDetailsBaseItemsByPricingIds/';
    return AuthService.getInstance().CallBackendFunctionPut(url, data);
  }

  static EditPlanningDetailsItem(editedItem) {
    const url = 'api/VPlanningDetailsBase/PutVPlanningDetailsBase/';
    editedItem.EndDate = dateTimeHelper.toYYYYsMMsDD(editedItem.EndDate);
    editedItem.StartDate = dateTimeHelper.toYYYYsMMsDD(editedItem.StartDate);
    editedItem.NumberOfPlannedAssignments = parseInt(editedItem.NumberOfPlannedAssignments);

    return AuthService.getInstance().CallBackendFunctionPut(url, editedItem);
  }

  static UpdateMultiplePlanningDetailItemStatusByPricingIds(editedPlanningItems, applyDateRow, newStatus) {
    const pricingIds = [];
    editedPlanningItems.forEach((item) => pricingIds.push(item.PricingId));

    const idsJSON = JSON.stringify(pricingIds);
    const applyDateRowJSON = JSON.stringify(applyDateRow);
    const data = {
      Ids: idsJSON,
      ApplyDateRow: applyDateRowJSON,
      NewStatus: newStatus
    };
    return AuthService.getInstance().CallBackendFunctionPut(
      'api/VPlanningDetailsBase/UpdateMultiplePlanningDetailItemStatusByPricingIds/',
      data
    );
  }

  static AddNewPlanningDetailItemsByPricingIds(editedPlanningItems, numberOfNewItems) {
    const pricingIds = [];
    editedPlanningItems.forEach((item) => pricingIds.push(item.PricingId));

    const idsJSON = JSON.stringify(pricingIds);
    const data = {
      Ids: idsJSON,
      NumberOfNewItems: numberOfNewItems.toString()
    };

    return AuthService.getInstance().CallBackendFunctionPut(
      'api/VPlanningDetailsBase/AddNewPlanningDetailItemsByPricingIds/',
      data
    );
  }

  static ConvertDBPlanningDetailsItems(PlanningDetailsItems) {
    const convertedPlanningDetailsItems = [];

    PlanningDetailsItems.forEach((item) => {
      const newItem = new PlanningDetailsItem(item);
      convertedPlanningDetailsItems.push(newItem);
    });

    return convertedPlanningDetailsItems;
  }

  static ConvertDBPlanningDetailsForReportingItems(PlanningDetailsForReportingItems) {
    const convertedPlanningDetailsForReportingItems = [];

    PlanningDetailsForReportingItems.forEach((item) => {
      const newItem = new PlanningDetailsForReportingItem(item);
      convertedPlanningDetailsForReportingItems.push(newItem);
    });

    return convertedPlanningDetailsForReportingItems;
  }
}

export default PlanningDetailsItemService;
